import React from 'react';
import styled from 'styled-components';
import { SuiNotificationBase, SuiNotificationPopover } from '@splashthat/sui';

const Paragraph = styled.p`
    padding: 1.5rem 0;

    @media only screen and (max-device-width: 812px) {
        padding: 1rem 0;
    }
`;

export default function TermsAndConditionsNotification() {
    const messageSection = (
        <Paragraph>
            By clicking the button above to proceed to the event, I agree that I have read, understand, and agree to be
            bound by Splash’s <a href="https://splashthat.com/terms">Terms and Conditions</a> and{' '}
            <a href="https://splashthat.com/privacy">Privacy Policy</a>.
        </Paragraph>
    );

    return (
        <SuiNotificationPopover>
            <SuiNotificationBase active disableTransition messageSection={messageSection} />
        </SuiNotificationPopover>
    );
}
